import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';

import {OfflineComponent} from './components/offline/offline.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {MaintainancePageComponent} from './components/maintainance-page/maintainance-page.component'

import {LoginComponent} from './components/login/login.component'
import {MsalGuard,MsalRedirectComponent} from '@azure/msal-angular';
import {AuthGuard} from './Shared/Services/authGuard'



const routes: Routes = [
  { path: "", component: HomeComponent },
 
  { path: "error", component: AccessDeniedComponent,canActivate: [MsalGuard] },
  { 
    path: 'home', component: HomeComponent,canActivate: [MsalGuard] },

  { path: 'offline', component: OfflineComponent },
  { path:'404', component :PageNotFoundComponent,canActivate: [MsalGuard]},
  {path:'maintainance',component:MaintainancePageComponent},
  { path: '**', redirectTo: '/404' },
  {  path: 'auth',
  component: MsalRedirectComponent}
];


const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled',
    useHash: true,
    initialNavigation: !isIframe ? 'enabled' : 'disabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
